<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý kích hoạt bảo hành</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('warranty_activation', 'view')">
        <div class="box-top-list">
          <span class="p-m-0 format-title">Chi tiết kích hoạt bảo hành</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="box-info p-fluid p-grid">
          <div class="p-col-5">
            <div class="box-info-title">THÔNG TIN KHÁCH HÀNG</div>
            <div class="form-info">
              <div class="p-field">
                <label>Tên khách hàng</label>
                <span>{{ full_name }}</span>
              </div>
              <div class="p-field">
                <label>Số điện thoại</label>
                <span>{{ phone_number }}</span>
              </div>
              <div class="p-field">
                <label>Nhóm khách hàng</label>
                <span>{{ group_customer }}</span>
              </div>
            </div>
            <div class="box-info-title">THÔNG TIN KÍCH HOẠT</div>
            <div class="form-info" v-if="dynamicForms && dynamicForms.length">
              <div class="p-field">
                <label>Ngày bán sản phẩm</label>
                <span>{{ date_of_sale }}</span>
              </div>
              <div  class="p-field" :key="index" v-for="(item, index) in dynamicForms">
                <label>{{ item.name }}</label>
                <span>{{ item.value }}</span>
             </div>
            </div>
            <div class="form-info" v-else>
              <div class="p-field">
                <label>Ngày bán sản phẩm</label>
                <span>{{ date_of_sale }}</span>
              </div>
            </div>
          </div>
          <div class="p-col-5 p-offset-1" >
            <div class="box-info-title"  v-if="lstImages && lstImages.length">HÓA ĐƠN BÁN HÀNG</div>
            <div class="box-invoice" v-if="lstImages && lstImages.length">
              <CoolLightBox
                class="box-invoice-img"
                :items="lstImages" 
                :index="indexInvoice"
                :fullScreen="true"
                :thumbsPosition="'center'"
                @close="indexInvoice = null">
              </CoolLightBox>

              <div class="images-wrapper">
                <div
                  class="image"
                  v-for="(image, imageIndex) in lstImages"
                  :key="imageIndex"
                  @click="setIndex(imageIndex)"
                  :style="{ backgroundImage: 'url(' + image.src + ')' }"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-info list-product">
          <div class="box-info-title">DANH SÁCH SẢN PHẨM</div>
          <div class="list-data">
            <BaseCommon v-if="dataModel"
              :key="componentKey"
              :listData="listData"
              :model="dataModel"
              :isFilter="false"
              :labelHeaderAction="'Chi tiết'"
              :pagination="false"
              :isCheckBox="isCheckBox"
              :actions="getRowActions()"
              :arrCheckBoxHidden="arrCheckBoxHidden"
              @row-select="onRowSelected"
              @row-select-all="onRowSelectedAll"
              v-on:action-click="onActionClicked"
            ></BaseCommon>
            <span v-if="lstProducts && lstProducts.length == 0 && submitCheck" class="txt-right custom-error"> Vui lòng chọn sản phẩm </span>
          </div>
          <div :class="'btn-function'" v-if="enableButton">
            <Button :label="'Nghiệm thu'" @click="acceptVerify"/>
            <Button class="p-button-warning"  :label="'Không nghiệm thu'" @click="rejectVerify"/>
          </div>
        </div>
        <div class="box-top-list last-changed">
          <span class="p-m-0 format-title">Lịch sử kích hoạt bảo hành</span>
        </div>
        <div class="box-info log-changed">
          <div class="list-data">
            <BaseCommon v-if="dataModelLog"
              :key="componentKeyLog"
              :listData="listDataLog"
              :model="dataModelLog"
              :isFilter="false"
              :pagination="true"
            ></BaseCommon>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      class="dialog-reject"
      :key="componentRejectKey"
      :visible.sync="showRejectDialog"
      :contentStyle="{overflow: 'visible'}"
      :style="{width: '50vw'}"
      :modal="true"
      :showHeader="false"
    >
      <div class="dialog-content">
        <p class="txt-center">Xác nhận không nghiệm thu sản phẩm?</p>
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label>Lý do không nghiệm thu <span class="error">*</span></label>
              </div>
              <div class="p-field">
                <Dropdown @input="changeReason" v-model="reasonItem" :options="reasonTypes" optionLabel="name" placeholder="Chọn lý do" />
                  <p class="txt-right"><small v-if="submitReject && Object.keys(reasonItem).length == 0"
                        class="p-invalid" >Chọn lý do</small></p> 
                  <p class="txt-right"><small v-if="submitReject && Object.keys(reasonItem).length > 0 && reasonItem.is_change_product && lstProducts.length > 1"
                        class="p-invalid" >Vui lòng chọn thực hiện từng sản phẩm cho lý do này</small></p>
              </div>
            </div>
            <div class="p-col-8 form-popup-custom" v-if="reasonItem != undefined && reasonItem != null && reasonItem.is_change_product && lstProducts.length == 1">
              <div class="p-field">
                <label>Serial number mới <span class="error">*</span></label>
              </div>
              <div class="p-field">
                <InputText maxlength="255" id="changed_serial_number_id" type="text" v-model="changed_serial_number_id"/>
                <p class="txt-right"><small v-if="submitReject && errorReject > 0"
                        class="p-invalid" >{{ errorReasonNote }}</small></p>
              </div>
            </div>
            <div class="p-col-12 form-popup-custom" v-if="reasonItem != undefined && reasonItem != null && reasonItem.is_add_note">
              <div class="p-field">
                <Textarea  :autoResize="true" rows="2" v-model="reason_note" placeholder="Nhập lý do chi tiết *"/>
                <p class="txt-right"><small v-if="submitReject && errorReject > 0 && reason_note.length == 0"
                        class="p-invalid" >Vui lòng nhập lý do chi tiết</small></p>
              </div>
            </div>
        </div>
      </div>
      <template #footer>
        <Button  label="Đồng ý" @click="acceptReject()" />
        <Button label="Huỷ" class="p-button-danger"  @click="closeReject"/>
      </template>
    </Dialog>
    <!--bỏ chặn scroll popup :contentStyle="{overflow: 'visible'}"-->
    <Dialog
      class="dialog-reject popup-dialog"
      :key="componentAcceptKey"
      :visible.sync="showAcceptDialog"
      :style="{width: '40vw'}"
      :modal="true"
      :showHeader="false"
    >
      <div class="dialog-content">
        <p class="txt-center">Xác nhận nghiệm thu sản phẩm?</p>
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label>Ngày nghiệm thu <span class="error">*</span></label>
              </div>
              <div class="p-field">
                <Calendar @input="changeInput" style="width: 250px;" id="date_verify" :showOnFocus="false" v-model="date_verify" :showIcon="true" />
                <p class="txt-right" style="width: 250px;"><small v-if="submitAccept && date_verify.length == 0"
                        class="p-invalid" >Nhập ngày nghiệm thu</small></p>
              </div>
            </div>
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label>Ghi chú</label>
              </div>
              <div class="p-field">
                <Textarea v-model="reason_verify" :autoResize="true" rows="2"/>
              </div>
            </div>
            <div class="p-col-12 form-popup-custom">
              <div class="p-field">
                <label>Biên bản nghiệm thu <span v-if="isInvoice" class="error">*</span></label>
              </div>
              <div class="p-field">
                <Button :label="'Chọn'" icon="pi pi-plus" @click="openFile" />
                <input id="files" ref="files" type="file" multiple style="display:none" @change="chooseFile"/>
              </div>
              <p class="txt-right"><small v-if="submitAccept && isInvoice && files.length == 0"
                        class="p-invalid" >Đính kèm biên bản nghiệm thu</small></p>
            </div>
            <div class="p-col-12 form-popup-custom box-list-img"  v-if="files && files.length">
              <CoolLightBox
                :items="files" 
                :index="indexUpload"
                :fullScreen="true"
                @close="indexUpload = null">
              </CoolLightBox>
              <div class="images-wrapper p-grid">
                <div class="p-col-3 item-img"   :key="indexImg" v-for="(itemImg, indexImg) in files">
                  <div class="item" >
                    <div class="remove-icon" @click="removeImg(indexImg)"> <span class="pi pi-times" ></span></div>
                    <div class="image" :style="{ backgroundImage: 'url(' + itemImg.src + ')' }" @click="indexUpload = indexImg"></div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <template
        #footer
      >
        <Button label="Đồng ý" @click="acceptAction()" />
        <Button label="Huỷ" class="p-button-danger"  @click="closeAccept"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import Api from '@/services'
import $ from 'jquery'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      files: [],
      listData: [],
      dataModel: null,
      listDataLog: [],
      dataModelLog: null,
      componentKey: Math.random()*100,
      componentKeyLog: Math.random()*560,
      full_name: '',
      phone_number: '',
      group_customer: '',
      date_of_sale: '',
      invoiceImages: [],
      invoiceImagesTmp: [],
      lstImages: [],
      indexInvoice: null,
      indexUpload: null,
      showRejectDialog: false,
      showAcceptDialog: false,
      reasonTypes: [],
      reasonItem: {},
      lstProducts: [],
      submitCheck: false,
      date_verify: moment(new Date()).format('DD/MM/YYYY'),
      reason_verify: '',
      status: 0,
      submitAccept: false,
      id: 0,
      changed_serial_number_id: '',
      serial_number_id: 0,
      reason_note: '',
      submitReject: false,
      errorReject: -1,
      errorReasonNote: '',
      isInvoice: false,
      componentAcceptKey: Math.random()*2389,
      componentRejectKey: Math.random()*1209,
      organizationID: 0,
      acceptance_images: [],
      acceptance_images_string: [],
      enableButton: false,
      dynamicForms: [],
      isCheckBox: true,
      arrCheckBoxHidden: ['verify_status']
    }
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.id = Number(this.$route.params.id);
      this.initData();
    }
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('warranty_activation', 'view')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      await this.getSetting();
      await this.getData(this.id);
      await this.getDataProduct(this.id);
      await this.getDataLog(this.id);
      await this.getDynamicForm(this.id);
      if (this.isCheckBox) {
        $('.checkbox-hidden').each(function() {
          if ($(this).val() == 'checkbox-1' || $(this).val() == 'checkbox-2') {
            $(this).closest('tr').find('td:first-child').html('');
          }
        });
      }
      this.$store.commit('setLoading', false);
    },
    async getSetting() {
      var variables = {
        where_key: {
          key: {'_eq': 'REQUIRED_UPLOAD_IMAGE_CONTRACT'}
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), "fields": "value"});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null && list.length > 0) {
        this.isInvoice = (list[0].value == 'true');
      }
    },
    async settingReasonReject() {
      var variables = {
        where_key: {
          status: {'_in': [1] },
          reason_type: {'_eq': 'not_accepted'}
        },
        orderBy: {
          ordering: 'asc'
        }
      }
      var data = await DataServices.getList('setting_reason_reject', {"variables": JSON.stringify(variables), "fields": "id code reason_name  reason_type is_add_note is_change_product"});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null) {
        for (let index = 0; index < list.length; index++) {
          const ele = list[index];
          this.reasonTypes.push({name: ele.reason_name , value: ele.id, is_add_note: ele.is_add_note, is_change_product: ele.is_change_product, code: ele.code, reason_type: ele.reason_type});
        }
      }
    },
    changeInput($event) {
      var date = new Date($event);
      var dateNow = new Date();
      if (dateNow < date) this.date_verify = moment(dateNow).format('DD/MM/YYYY');
      else this.date_verify = moment(date).format('DD/MM/YYYY');
    },
    async getData(id) {
      var modelName = 'request_activation';
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables), 'fields': 'customer_type customer_name  status customer_profile { full_name phone_number  user { user_type } } invoice_images date_of_sale'});
      var list = data[Object.keys(data)];
      
      if (list != undefined && list != null && Object.keys(list).length > 0) {
        var records = list[0];
        var userType = (records.customer_profile.user != undefined && records.customer_profile.user != null) ? records.customer_profile.user.user_type : 0;
        if (records.customer_profile != undefined && records.customer_profile != null) {
          this.full_name = records.customer_profile.full_name;
          this.phone_number = records.customer_profile.phone_number;
          this.phone_number = this.phone_number.replace('+84', '0');
        }
        if (records.customer_name != undefined && records.customer_name != null ) {
          this.full_name = records.customer_name;
        }
        if (records.customer_type != undefined && records.customer_type != null ) {
          userType = records.customer_type;
        }

        if (userType == 1) this.group_customer = 'Cá nhân';
        else if (userType == 2) this.group_customer = 'Doanh nghiệp';

        this.status = records.status;
        //this.date_of_sale = moment.utc(records.date_of_sale).local().format('DD/MM/YYYY');
         this.date_of_sale =  moment.tz(records.date_of_sale, this.$myConstants.timeZone()).format("DD/MM/yyyy");
        this.invoiceImages = [];
        this.invoiceImagesTmp = [];
        if(records.invoice_images != null && records.invoice_images != '') {
          this.invoiceImagesTmp = records.invoice_images;
          var images = this.$myConstants.isJSON(records.invoice_images);
          if (images != false) {
            var json = JSON.parse(records.invoice_images);
            this.invoiceImages = json;
          } else this.invoiceImages = images;
        }
        if (this.invoiceImages != null) {
          for (let index = 0; index < this.invoiceImages.length; index++) {
            var item = this.invoiceImages[index];
            var path = item.url != undefined ? item.url : (item.cdn != null ? item.cdn + '' + item.path : item.path);
            this.lstImages.push({src: path});
          }
        }
      }
    },
    async getDataProduct(id) {
      var name = 'request_activation_product_serial';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': id },
          status: {'_eq': 1}
        }
      }
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": "id serial_number_id activation_date verify_status warranty_status product_serial_number { id serial_number product {id model_code name warranty_time warranty_unit is_maintenance type_maintenance } warranty_status product_serial_number_info { customer_profile_id organization_id warranty_status verify_status warranty_time warranty_unit } }"});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(name);
      this.dataModel.processData(list);
      this.listData = list;
      this.enableButton = false;     
      if(this.checkVisible('warranty_activation', 'accepted')) {
        var returnAllow = this.listData.filter(a => a.verify_status == 0);
        if (returnAllow && Object.keys(returnAllow).length) this.enableButton = true;
      }
      this.componentKey = Math.random()*100;
    },
    async getDataLog(id) {
      var nameLog = 'request_activation_changed_log';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': id},
          status: {'_in': [0, 1]}
        },
        orderBy: {
          id: 'desc'
        }
      }
      var data = await DataServices.getList(nameLog, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModelLog = DataServices.getModel(nameLog);
      this.dataModelLog.processData(list);
      this.listDataLog = list;
      this.componentKeyLog = Math.random()*10;
    },
    async getDynamicForm(id) {
      this.dynamicForms = [];
      var nameDynamic = 'product_serial_number_dynamic_form';
      var variables = {
        where_key: {
          request_activation_id: {'_eq': id},
          status: {'_eq': 1}
        }
      }
      var data = await DataServices.getList(nameDynamic, {"variables": JSON.stringify(variables), "fields": "serial_number_id data_dynamic_form"});
      var list = data[Object.keys(data)];
      if (list && list != null && Array.isArray(list) && list.length) {
        var dataDynamic = list[0];
        if (dataDynamic.data_dynamic_form !== undefined && dataDynamic.data_dynamic_form != null && Object.keys(dataDynamic.data_dynamic_form).length) {
          var forms = JSON.parse(dataDynamic.data_dynamic_form);
          if (forms && forms != null && Array.isArray(forms) && forms.length) {
            for (let index = 0; index < forms.length; index++) {
              const item = forms[index];
              if (item && item.fields && item.fields != null && Object.keys(item.fields).length) {
                var dynamicName = item.fields.name;
                var dynamicValue = item.fields.value;
                if (item.fields.backend_type == 'date' && item.fields.validation != undefined && item.fields.validation != null) {
                  var validation =  JSON.parse(item.fields.validation);
                  if (dynamicValue != null && validation.date && validation.date.format != undefined && validation.date.format != '') {
                    dynamicValue = moment(dynamicValue).format(validation.date.format);
                  }
                }
                this.dynamicForms.push({name: dynamicName, value: dynamicValue});
              }
            }
          }
        }
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/warranty-activation/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
          this.$router.push(action.path + '/' + data.data[action.key])
          break;
      }
    },
    backList() {
       this.$router.push({path: '/admin/warranty-activation'});
    },
    changeReason() {
      this.submitReject = false;
    },
    
    async checkSeiralNumber(serialNumber) {
      this.errorReject = -1;
      var returnData = this.lstProducts.filter(a => a.serial_number == serialNumber);
      if (returnData && Object.keys(returnData).length) {
        this.errorReject = 1;
        this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
      }
      else {
        var variables = {
          where_key: {
            product_serial_number: {
              serial_number: {'_eq': serialNumber },
              production_status: {'_eq': 1},
              status: {'_eq': 1}
            },
            status: {'_eq': 1}
          }
        }
        var data = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variables), "fields": "serial_number_id product_id product_serial_number { serial_number  } products { model_code } warranty_status verify_status"});
        var list = data[Object.keys(data)];
        if (list != null && list.length > 0) {
          var dataSerial = list[0];
          this.changed_serial_number_new_id = dataSerial.serial_number_id;
          var serialNumberCode = dataSerial.products.model_code;
          var modelData = this.lstProducts.filter(a => a.model_code == serialNumberCode);
          if (modelData && modelData.length) {
            if (dataSerial.warranty_status == 1 || dataSerial.warranty_status == 3 || dataSerial.warranty_status == 4) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đã kích hoạt bảo hành. Vui lòng nhập lại serial number';
            } else if (dataSerial.warranty_status == 2) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đang chờ kích hoạt bảo hành.Vui lòng nhập lại serial number';
            } else {
              this.errorReject = 0;
              this.errorReasonNote = '';
            }
          } else {
            this.errorReject  = 1;
            this.errorReasonNote = 'Vui lòng đổi sản phẩm mới cùng mã sản phẩm cũ';
          }
        } else {
          var variables1 = {
            where_key: {
              serial_number: {'_eq': serialNumber },
              production_status: {'_eq': 1},
              status: {'_eq': 1}
            }
          }
          var data1 = await DataServices.getList('product_serial_number', {"variables": JSON.stringify(variables1), "fields": "id serial_number warranty_status product { model_code }"});
          var list1 = data1[Object.keys(data1)];
          if (list1 != null && list1.length > 0) {
            var dataSerial1 = list1[0];
            if (dataSerial1.warranty_status == 1 || dataSerial1.warranty_status == 3) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đã kích hoạt bảo hành. Vui lòng nhập lại serial number';
            } else if (dataSerial1.warranty_status == 2) {
              this.errorReject = 1;
              this.errorReasonNote = 'Serial number đang chờ kích hoạt bảo hành.Vui lòng nhập lại serial number';
            } else {
              var serialNumberModelCode = dataSerial1.product.model_code;
              var modelSerial = this.lstProducts.filter(a => a.model_code == serialNumberModelCode);
              if (modelSerial && modelSerial.length) {
                this.errorReject = 0;
                this.changed_serial_number_new_id = dataSerial1.id;
              } else {
                this.errorReject = 1;
                this.errorReasonNote = 'Vui lòng nhập mã serial cùng model với sản phẩm cũ'; 
              }
            }
          } else  {
            this.errorReject = 1;
            this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
          }
        }
      }
    },
    async acceptReject() {
      this.$store.commit('setDataLoading', {content: 'Đang kiểm dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.errorReject = -1;
      this.submitReject = true;
      if (this.reasonItem == undefined || this.reasonItem == null || Object.keys(this.reasonItem).length == 0) {
        this.errorReject = 1;
      }
      else {
        this.reason_note = this.reason_note.trim();
        if (this.reasonItem.is_add_note && (this.reason_note == '' || this.reason_note.length == 0)) {
          this.errorReject = 1;
        } else if (this.reasonItem.is_change_product && (this.changed_serial_number_id == '' || this.changed_serial_number_id.length == 0)) {
          this.errorReject = 1;
          this.errorReasonNote = 'Vui lòng chọn sản phẩm thay thế';
        } else this.errorReject = 0;
      }
      if (this.changed_serial_number_id != '') {
        // console.log('ffffffffffffffffffff')
        // check seriral co trong he thong khong
        await this.checkSeiralNumber(this.changed_serial_number_id);
      }
      // if (this.changed_serial_number_id != '' && (this.changed_serial_number_new_id == '' || this.changed_serial_number_new_id == null)) {
      //   this.errorReject = 1;
      //   this.errorReasonNote = 'Vui lòng đổi sản phẩm mới cùng mã sản phẩm cũ';
      //   console.log('tttt');
      //   // console.log('ttttttttttt', this.changed_serial_number_id, this.changed_serial_number_new_id, this.errorReasonNote)
      // }
      // console.log('aaaaaaaaaaaaaaaaa', this.errorReject);
      if (this.submitReject && this.errorReject == 0 && this.lstProducts.length > 0) {
        // console.log('dddddddddđ');
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var k = 0;
        // console.log('ddddddđ', vm.lstProducts);
        while (k < vm.lstProducts.length) {
          await vm.processReject(vm.lstProducts[k], k);
          if (k == (vm.lstProducts.length - 1)) {
            await vm.checkProcessAllProduct();
            this.$store.commit('setLoading', false);
            vm.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
            vm.showRejectDialog = false;
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
          k++;
        }
      } else this.$store.commit('setLoading', false);
    },
    async checkProcessAllProduct() {
      var dataAll = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({ where_key: { request_activation_id: {'_eq': this.id }, verify_status: {'_eq': 0} } }), "fields": "id"});
      var listAll = dataAll[Object.keys(dataAll)];
      if (listAll == null || (listAll != null && listAll.length == 0)) {
        var status = (this.changed_serial_number_id != '' && this.changed_serial_number_new_id != '') ? 0 : 1; 
        await DataServices.updateData('request_activation', {"variables": JSON.stringify({data_update: {process_status: 1, status: status}, where_key: {id: {'_eq': this.id}}})});
      }
    },
    async processReject(info, index) {
      var customerID = 0;
      var organizationID = 0;
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      organizationID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.organization_id : 0;
      customerID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.customer_profile_id : 0;
      
      // cập nhật trạng thái không nghiệm thu cho request_activation_product_serial
      var whereKey = { request_activation_id: {'_eq': this.id }, serial_number_id: {'_eq': info.serial_number_id } }
      var paramsUpdate = { modified_date: this.$myConstants.currentDate(), verify_status: 2,  warranty_status: 0}
      await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});
      
      
      // tạo log request_activation_changed_log
     
      var rowActivationChangeLog = {}, oldValue = {}, newValue = {};
      var dataActivation = await DataServices.getList('request_activation', {"variables": JSON.stringify({ where_key: { id : {'_eq': this.id } } })});
      var listActivation = dataActivation[Object.keys(dataActivation)];
      if (listActivation != null && listActivation.length > 0) {
        oldValue = listActivation[0];
        // organizationID = (oldValue['organization_id'] != undefined && oldValue['organization_id'] != null) ? oldValue['organization_id'] : 0;
        newValue = oldValue;
      }
     
      if (index == 0) {
        var message = 'Không nghiệm thu '+ this.lstProducts.length + ' sản phẩm';
        if (this.changed_serial_number_id != '' && this.changed_serial_number_id.length > 0) {
          message = 'Không nghiệm thu '+ this.lstProducts.length + ' sản phẩm. Đổi serial number mới: ' + this.changed_serial_number_id;
        }
        newValue['message'] = message;

        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'request_activation_id': this.id });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'modifier_id': this.$store.getters.fullname.id });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'organization_id':  organizationUser });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'message': message });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'created_date': this.$myConstants.currentDate() });
        rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'modified_date': this.$myConstants.currentDate() });
        if (oldValue && Object.keys(oldValue).length > 0) rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'old_value': JSON.stringify(oldValue) });
        if (newValue && Object.keys(newValue).length > 0) rowActivationChangeLog = Object.assign(rowActivationChangeLog, { 'new_value': JSON.stringify(newValue) });

        await DataServices.insertData('request_activation_changed_log', {"variables": JSON.stringify({objects: rowActivationChangeLog})});
      }

      var oldSerialInfo = {}, newSerialInfo = {};
      var warrantyStatus = 0;
      // kiểm tra xem đã có kích hoạt trước đó chưa
      var dataWarranty = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify({ where_key: { serial_number_id: {'_eq': info.serial_number_id } } }), "fields": "serial_number_id product_id request_activation_id product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit change_time change_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit change_time change_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form"});
      var listWarranty = dataWarranty[Object.keys(dataWarranty)];
      // tắt kích hoạt nếu đã kích hoạt thành công trước đó
      if (listWarranty != null && Object.keys(listWarranty).length > 0) {
        oldSerialInfo = listWarranty[0];
        newSerialInfo = oldSerialInfo;
        warrantyStatus = (oldSerialInfo.warranty_status != null && (oldSerialInfo.warranty_status == 1 || oldSerialInfo.warranty_status == 3) ? 5 : 0);
      }

      var paramsInfo = {};
      paramsInfo = Object.assign(paramsInfo,  {request_activation_id: this.id});
      paramsInfo = Object.assign(paramsInfo,  {modified_date: this.$myConstants.currentDate()});
      paramsInfo = Object.assign(paramsInfo,  {verify_status: 2});
      paramsInfo = Object.assign(paramsInfo,  {warranty_status: warrantyStatus});
      await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsInfo, where_key: { serial_number_id: {'_eq': info.serial_number_id } }})});
      

      newSerialInfo['warranty_status'] = warrantyStatus;
      newSerialInfo['verify_status'] = 2;
      newSerialInfo['message'] = this.reasonItem.name;
      if (this.changed_serial_number_id != '') {
        newSerialInfo['message']+= '.Serial number mới ' + this.changed_serial_number_id;
      }
      if (this.reason_note != '') {
        newSerialInfo['message']+= '. ' + this.reason_note;
      }

      newSerialInfo['organization_id'] = organizationUser;
      

      var rowSerialChangeLog = {};
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'request_activation_id': this.id })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'serial_number_id': info.serial_number_id })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'old_value': JSON.stringify(oldSerialInfo) })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'new_value': JSON.stringify(newSerialInfo) })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'created_date': this.$myConstants.currentDate() })
      rowSerialChangeLog = Object.assign(rowSerialChangeLog, { 'modified_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: rowSerialChangeLog})});
      

      var paramsStatusChange = {}
      paramsStatusChange = Object.assign(paramsStatusChange, { 'request_activation_id': this.id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'serial_number_id': info.serial_number_id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'old_warranty_status': info.warranty_status })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'old_verify_status': info.verify_status})
      paramsStatusChange = Object.assign(paramsStatusChange, { 'new_warranty_status': warrantyStatus})
      paramsStatusChange = Object.assign(paramsStatusChange, { 'new_verify_status': 2 })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'modifier_id': this.$store.getters.fullname.id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'customer_profile_id': customerID })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'organization_id': organizationID })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'reason_type': this.reasonItem.reason_type })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'reason_code': this.reasonItem.code })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'source': 'web' })
      if (this.reason_note.length > 0) paramsStatusChange = Object.assign(paramsStatusChange, { 'note': this.reason_note })
      if (this.changed_serial_number_id.length > 0) paramsStatusChange = Object.assign(paramsStatusChange, { 'changed_serial_number_id': this.changed_serial_number_new_id })
      paramsStatusChange = Object.assign(paramsStatusChange, { 'created_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: paramsStatusChange})});
      
      // // đổi sản phẩm khác
      if (this.changed_serial_number_id != '' && this.changed_serial_number_new_id != '') {
        // console.log('vao day')
        this.createProductInfoToRequest(customerID, organizationID, info.serial_number);
      }
      // this.showRejectDialog = false;
    },
    async createProductInfoToRequest(customerID, organizationID, serial_number) {
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      var dataNewProductSerial = {};
      dataNewProductSerial['request_activation_id'] = this.id;
      dataNewProductSerial['serial_number_id'] = this.changed_serial_number_new_id;
      dataNewProductSerial['created_date'] =  this.$myConstants.currentDate();
      dataNewProductSerial['modified_date'] =  this.$myConstants.currentDate();
      dataNewProductSerial['user_id'] =  this.$store.getters.fullname.id;
      dataNewProductSerial['activation_date'] =  this.$myConstants.currentDate();
      dataNewProductSerial['warranty_status'] = 2;
      dataNewProductSerial['verify_status'] = 0;
      dataNewProductSerial['status'] = 1;
      var dataProductSerial = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({ where_key: { serial_number_id: {'_eq': this.changed_serial_number_new_id }, request_activation_id: {'_eq': this.id } } }), "fields": "serial_number_id request_activation_id"});
      dataProductSerial = dataProductSerial[Object.keys(dataProductSerial)];
      if (dataProductSerial != null && Object.keys(dataProductSerial).length > 0) {
        await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: dataNewProductSerial, where_key: {serial_number_id: {'_eq': this.changed_serial_number_new_id }, request_activation_id: {'_eq': this.id }}})});  
      } else {
        // console.log('dataNewProductSerial', dataNewProductSerial)
        await DataServices.insertData('request_activation_product_serial', {"variables": JSON.stringify({objects: dataNewProductSerial})});
      }

      var newValue = {};
      var dataSerialInfo = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify({ where_key: { serial_number_id: {'_eq': this.changed_serial_number_new_id }, status: {'_eq': 1} } }), "fields": "serial_number_id product_id request_activation_id product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit is_manually_verification}} customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form"});
      dataSerialInfo = dataSerialInfo[Object.keys(dataSerialInfo)];
      if (dataSerialInfo != null && Object.keys(dataSerialInfo).length > 0) {
        newValue = dataSerialInfo[0];
        var dataNewSerialInfo = {
          request_activation_id: this.id,
          modified_date: this.$myConstants.currentDate(),
          verify_status: 0,
          warranty_status: 2
        }
        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: dataNewSerialInfo, where_key: { serial_number_id: {'_eq': this.changed_serial_number_new_id }}})});
      } else {
        var dataNewSerialInfoChange = {
          serial_number_id: this.changed_serial_number_new_id,
          customer_profile_id: customerID,
          organization_id: organizationID,
          request_activation_id: this.id,
          warranty_status: 2,
          verify_status: 0,
          status: 1,
          created_date: this.$myConstants.currentDate(),
          modified_date: this.$myConstants.currentDate()
        };
        var variablesProduct = {where_key: { product_serial_number: { id: {'_eq': this.changed_serial_number_new_id }, status: {'_eq': 1} }, production_status: {'_eq': 1}, status: {'_eq': 1} } }
        var dataProduct = await DataServices.getList('product', {"variables": JSON.stringify(variablesProduct), "fields": "id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time returnable_unit change_time change_unit last_modifier is_manually_verification qr_code_size category_id"});
        var listProduct = dataProduct[Object.keys(dataProduct)];
        if (listProduct != null && listProduct.length > 0) {
          var rowProduct = listProduct[0];
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {product_id: rowProduct.id});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {model_code: rowProduct.model_code});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {name: rowProduct.name});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {description: rowProduct.description});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {thumbnail_id: rowProduct.thumbnail_id});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {warranty_time: rowProduct.warranty_time});
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {warranty_unit: rowProduct.warranty_unit });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {is_returnable: rowProduct.is_returnable });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {returnable_time: rowProduct.returnable_time });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {returnable_unit: rowProduct.returnable_unit });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {change_time: rowProduct.change_time });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {change_unit: rowProduct.change_unit });

          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {last_modifier: rowProduct.last_modifier });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {is_manually_verification: rowProduct.is_manually_verification });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {qr_code_size: rowProduct.qr_code_size });
          dataNewSerialInfoChange = Object.assign(dataNewSerialInfoChange,  {category_id: rowProduct.category_id });
         

        }

        newValue = dataNewSerialInfoChange;
        
        // newValue['request_activation'] = {id: this.id}
        // console.log('dnewValue', newValue)
        await DataServices.insertData('product_serial_number_info', {"variables": JSON.stringify({objects: dataNewSerialInfoChange})});
        
      }
      newValue['warranty_status'] = 2;
      newValue['verify_status'] = 0;
      newValue['organization_id'] = organizationUser;
      newValue['request_activation'] = {id: this.id};
      newValue['invoice_images'] = this.invoiceImagesTmp;
      newValue['message'] = 'Gửi yêu cầu kích hoạt bảo hành thay thế Serial number ' + serial_number; 
      // thêm product_serial_number_info_log_changed
      var dataNewChangeLog = {};
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'request_activation_id': this.id })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'serial_number_id': this.changed_serial_number_new_id})
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'modifier_id': this.$store.getters.fullname.id })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'new_value': JSON.stringify(newValue) })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'created_date': this.$myConstants.currentDate() })
      dataNewChangeLog = Object.assign(dataNewChangeLog, { 'modified_date': this.$myConstants.currentDate() })
      await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: dataNewChangeLog})});

      

      var dataNewStatusChange = {
        request_activation_id: this.id,
        serial_number_id: this.changed_serial_number_new_id, 
        new_warranty_status: 2,
        new_verify_status: 0,
        modifier_id: this.$store.getters.fullname.id,
        customer_profile_id: customerID,
        organization_id: organizationUser,
        modified_date: this.$myConstants.currentDate(),
        source: 'web'
      }

      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: dataNewStatusChange})});
     
    },
    async acceptAction() {
      this.submitAccept = true;
      var isProccess = false;
      if (this.isInvoice &&  this.files.length > 0)  isProccess = true;
      if (!this.isInvoice) isProccess = true;
      

      if (this.lstProducts.length > 0 && this.date_verify != '' && isProccess) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var vm = this;
        var checkUpload = true;
        var k = 0;
        if ( this.files.length > 0) {
          checkUpload = await this.uploadImages();  
        }
        if ( checkUpload) {
          while (k < vm.lstProducts.length) {
            await vm.processAccept(vm.lstProducts[k]);
            if (k == (vm.lstProducts.length - 1)) {
              await vm.updateActivationChangedAccept();
            }
            k++;
          }
        }
      }
    },
    async processAccept(info) {
      // console.log('sdfds', this.acceptance_images, info)
      var params = {}
      var customerID = 0;
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      this.organizationID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.organization_id : 0;
      customerID = (info.product_serial_number != undefined && info.product_serial_number != null && info.product_serial_number.product_serial_number_info != undefined && info.product_serial_number.product_serial_number_info != null) ? info.product_serial_number.product_serial_number_info.customer_profile_id : 0;

      params = Object.assign(params, { 'request_activation_id': this.id })
      params = Object.assign(params, { 'serial_number_id': info.serial_number_id })
      params = Object.assign(params, { 'old_warranty_status': info.warranty_status })
      params = Object.assign(params, { 'old_verify_status': info.verify_status})
      params = Object.assign(params, { 'new_warranty_status': 3})
      params = Object.assign(params, { 'new_verify_status': 1 })
      params = Object.assign(params, { 'modifier_id': this.$store.getters.fullname.id })
      params = Object.assign(params, { 'customer_profile_id': customerID})
      params = Object.assign(params, { 'organization_id': organizationUser })
      //Tuyến sửa anh Lâm check lộn
      if (this.reason_verify.length > 0) params = Object.assign(params, { 'note': 'Nghiệm thu sản phẩm ' + this.reason_verify })
      //if (this.reason_note.length > 0) params = Object.assign(params, { 'note': 'Nghiệm thu sản phẩm ' + this.reason_verify })
      params = Object.assign(params, { 'source': 'web' })

      var paramsUpdate = { modified_date: this.$myConstants.currentDate(), verify_status: 1, warranty_status: 3 }

      var dateActive = this.$myConstants.currentDate();
      if(this.date_verify != null && this.date_verify != '') {
        var dateNow = new Date();
        const [d, M, y] = this.date_verify.match(/\d+/g);
        var changeDate = new Date(y, M-1, d, dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());
        paramsUpdate = Object.assign(paramsUpdate,  {activation_date: changeDate.toUTCString()})
        params = Object.assign(params, { created_date: changeDate.toUTCString() })
        dateActive = this.$myConstants.currentDate(changeDate.toUTCString());
      }

    
      await DataServices.insertData('product_serial_number_info_status_changed', {"variables": JSON.stringify({objects: params})});
     
      var whereKey = { request_activation_id: {'_eq': this.id }, serial_number_id: {'_eq': info.serial_number_id } }
      

     
      await DataServices.updateData('request_activation_product_serial', {"variables": JSON.stringify({data_update: paramsUpdate, where_key: whereKey})});

      var variablesSerial = {
        where_key: {
          serial_number_id: {'_eq': info.serial_number_id },
          status: {'_eq': 1}
        }
      }
      var dataSerial = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id product_id request_activation_id customer_profile_id organization_id model_code name description thumbnail_id warranty_time warranty_unit is_returnable returnable_time  returnable_unit change_time change_unit is_manually_verification last_modifier is_manually_verification created_date modified_date qr_code_size category_id date_of_sale activation_date status  warranty_status verify_status invoice_images acceptance_images data_dynamic_form product_serial_number { serial_number warranty_status production_status production_order_code product_id status product { warranty_time warranty_unit returnable_time returnable_unit change_time change_unit is_manually_verification } }"});
      var listSerial = dataSerial[Object.keys(dataSerial)];
      if (listSerial != null && listSerial.length > 0) {
        var rowSerial = listSerial[0];
        var rowSerialNew = rowSerial;
        rowSerialNew['verify_status'] = 1;
        rowSerialNew['activation_date'] = dateActive;
        rowSerialNew['warranty_status'] = 3;
        rowSerialNew['modified_date'] = this.$myConstants.currentDate();
        var message = 'Nghiệm thu sản phẩm'
        if (this.reason_verify.length > 0) {
          message += '. ' + this.reason_verify;
        }
        rowSerialNew['message'] = message;


        var whereInfo = { serial_number_id: {'_eq': info.serial_number_id } }
        var paramsInfo = { modified_date: this.$myConstants.currentDate(), verify_status: 1, warranty_status: 3 }

        if(this.date_verify != null && this.date_verify != '') {
          var dateNowInfo = new Date();
          const [d, M, y] = this.date_verify.match(/\d+/g);
          var changeDateNew = new Date(y, M-1, d, dateNowInfo.getHours(), dateNowInfo.getMinutes(), dateNowInfo.getSeconds());
          paramsInfo = Object.assign(paramsInfo,  {activation_date: changeDateNew.toUTCString()})
        }
        
        rowSerialNew['acceptance_images'] = JSON.stringify(this.acceptance_images);
        rowSerialNew['organization_id'] = organizationUser;
       
        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: paramsInfo, where_key: whereInfo})});


        // console.log('dfdfgfd', rowSerialNew);

        var paramsInfoLog = {serial_number_id: info.serial_number_id, old_value: JSON.stringify(rowSerial), new_value: JSON.stringify(rowSerialNew), created_date: this.$myConstants.currentDate(), modified_date: this.$myConstants.currentDate(), modifier_id: this.$store.getters.fullname.id }
        // console.log('paramsInfoLog', paramsInfoLog);

        paramsInfoLog = Object.assign(paramsInfoLog, { 'request_activation_id': this.id })
       
        await DataServices.insertData('product_serial_number_info_log_changed', {"variables": JSON.stringify({objects: paramsInfoLog})});


        await DataServices.updateData('product_serial_number_info', {"variables": JSON.stringify({data_update: {acceptance_images:  JSON.stringify(this.acceptance_images)}, where_key: whereInfo})});

      }
      //Tạo bảo trì định kỳ nếu có
      this.addMaintence(info,this.id);
    },
    async addMaintence(info, request_activation_id) {
      var vm = this;
      var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      //Tạo bảo trì định kỳ nếu có
      if (!this.$myConstants.isEmpty(info.product_serial_number)) {
        if (!this.$myConstants.isEmpty(info.product_serial_number.product)) {
          var id_product = (!this.$myConstants.isEmpty(info.product_serial_number.product.id)) ? info.product_serial_number.product.id : 0;
          var whereObjectProduct = {
            id: {'_eq': id_product}
          }
          var product_detail = await DataServices.getObjectData('product', whereObjectProduct, {id: 'desc'});
          var is_maintenance = (!this.$myConstants.isEmpty(product_detail.is_maintenance)) ? product_detail.is_maintenance : null;
          var type_maintenance = (!this.$myConstants.isEmpty(product_detail.type_maintenance)) ? product_detail.type_maintenance : null;
          if (is_maintenance && is_maintenance == 1) {
            //Lấy danh sách các đợt bảo trì của sp
            var variables_maintenance = {
              where_key: {
                product_id: {_eq: id_product},
                status: {_eq: 1}
              },
              orderBy: {"parts_number": "asc"}
            }
            var product_maintenance = await DataServices.getListData('product_maintenance', {"variables": JSON.stringify(variables_maintenance)});
            //Lấy thông tin customer
            //var obj_customer = await this.$coreService.getCustomerByIdProfile(customerID);
            var obj_request_activation = await this.$coreService.getRequestActivationById(request_activation_id);
            var serial_user_id = (!this.$myConstants.isEmpty(obj_request_activation.customer_profile.user_id)) ? obj_request_activation.customer_profile.user_id : '';
            var serial_customer = {
              id: serial_user_id,
              full_name: (!this.$myConstants.isEmpty(obj_request_activation.customer_profile.full_name)) ? obj_request_activation.customer_profile.full_name : '',
              phone_number: (!this.$myConstants.isEmpty(obj_request_activation.customer_profile.phone_number)) ? obj_request_activation.customer_profile.phone_number : '',
              customer_type: (!this.$myConstants.isEmpty(obj_request_activation.customer_profile.customer_type)) ? obj_request_activation.customer_profile.customer_type : '',
              full_address: (!this.$myConstants.isEmpty(obj_request_activation.full_address)) ? obj_request_activation.full_address : '',
            };
            if (!this.$myConstants.isEmpty(obj_request_activation)) {
              if (!this.$myConstants.isEmpty(obj_request_activation.customer_name)) {
                serial_customer.full_name = obj_request_activation.customer_name;
              }
              if (!this.$myConstants.isEmpty(obj_request_activation.customer_type)) {
                serial_customer.customer_type = obj_request_activation.customer_type;
              }
            }
            var dataInsertMaintence = [];
            var sum_time_between_maintenance = 0;
            for (var m = 0; m < product_maintenance.length; m++) {
              sum_time_between_maintenance += (!this.$myConstants.isEmpty(product_maintenance[m].time_between_maintenance)) ? product_maintenance[m].time_between_maintenance : 0;
              var dataItemtMaintence = {
                date_maintenance: moment.tz((new Date().toUTCString()), this.$myConstants.timeZone()).add(sum_time_between_maintenance, 'M').format('YYYY-MM-DD'),// HH:mm:ss
                parts_number: (!this.$myConstants.isEmpty(product_maintenance[m].parts_number)) ? product_maintenance[m].parts_number : 0,
                time_between_maintenance: (!this.$myConstants.isEmpty(product_maintenance[m].time_between_maintenance)) ? product_maintenance[m].time_between_maintenance : 0,
                list_service_pack_id: (!this.$myConstants.isEmpty(product_maintenance[m].list_service_pack_id)) ? product_maintenance[m].list_service_pack_id : null,
                type_maintenance: type_maintenance,
                serial_user_id: serial_user_id,
                serial_number_id: info.serial_number_id,
                process_status: 0,
                status: 1,
                serial_customer: JSON.stringify(serial_customer),
                modifier_id: this.$store.getters.fullname.id,
                modified_date: this.$myConstants.currentDate(),
              };
              dataInsertMaintence.push(dataItemtMaintence);
            }
            if (dataInsertMaintence.length > 0) {
              var dataResrMantence =  await DataServices.insertData('maintenance', {"variables": JSON.stringify({objects: dataInsertMaintence})});
              if (!vm.$myConstants.isEmpty(dataResrMantence.insert_core_maintenance)) {
                if (!vm.$myConstants.isEmpty(dataResrMantence.insert_core_maintenance.returning)) {
                    var list_mantence_insert = dataResrMantence.insert_core_maintenance.returning;
                    var list_id_maintence = [];
                    for (var k=0;k<list_mantence_insert.length;k++){
                      list_id_maintence.push(list_mantence_insert[k].id);
                    }
                    if (list_id_maintence.length > 0){
                      vm.$coreService.updateStatusMaintence(vm.$dataCommon.MAINTENANCE.PROCESS_STATUS.PLAN, list_id_maintence, vm.$store.getters.fullname.id, creator_organization_id);
                    }
                }
              }
            }
          }
        }
      }
    },
    async uploadImages() {
      var countUpload = 0;
      if (this.files.length > 0) {
        var k = 0;
        var vm = this;
        while (k < vm.files.length) {
          var isUpload = await vm.uploadOneImages(k);
          if (isUpload) {
            k++;
            countUpload++;
          }
        }
      } else countUpload = 1;
      return countUpload > 0;
    },
    async uploadOneImages(k) {
      var vm = this;
      var returnData = '';
      var file = vm.files[k];
      let formData = new FormData();
      formData.append('file', file);
      await Api.post('/common/upload-s3', formData)
      .then((response) => {
        var obj = response.data.data;
        obj.path = obj.url;
        vm.acceptance_images.push(obj);
        vm.acceptance_images_string.push(response.data.data.url);
        returnData = response.data.data.url;
      })
      .catch((err) => {returnData = JSON.stringify(err)});
      return returnData.length > 0;
    },
    async updateActivationChangedAccept () {
      var organizationUser = (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null &&
      this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null
      && this.$store.getters.fullname.organization_account.organization_id != undefined && 
      this.$store.getters.fullname.organization_account.organization_id != null) ? this.$store.getters.fullname.organization_account.organization_id: 0;

      var variablesActivationChanged = {
        where_key: {
          request_activation_id: {'_eq': this.id },
          status: {'_eq': 1}
        },
        orderBy: {
          id: 'desc'
        },
        limit: 1
      }
      var oldValue = null;
      var dataActivationChanged = await DataServices.getList('request_activation_changed_log', {"variables": JSON.stringify(variablesActivationChanged), "fields": "id request_activation_id modifier_id organization_id message created_date modified_date status"});
      if(dataActivationChanged != null) {
        var listActivationChanged = dataActivationChanged[Object.keys(dataActivationChanged)];
        if (listActivationChanged != null && listActivationChanged.length > 0) {
          oldValue = listActivationChanged[0];
        }
      }
      var newValue = oldValue;
      var message = 'Nghiệm thu ' + this.lstProducts.length + ' sản phẩm';
      if (newValue != null) newValue['message'] = message;
      else newValue = { message: message}
      var paramsActivationLog = {};
      paramsActivationLog = Object.assign(paramsActivationLog, { 'request_activation_id': this.id });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'modifier_id': this.$store.getters.fullname.id });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'organization_id': organizationUser });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'message': message });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'old_value': JSON.stringify(oldValue) });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'new_value': JSON.stringify(newValue) });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'created_date': this.$myConstants.currentDate() });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'modified_date': this.$myConstants.currentDate() });
      paramsActivationLog = Object.assign(paramsActivationLog, { 'status': 1 });
      
      await DataServices.insertData('request_activation_changed_log', {"variables": JSON.stringify({objects: paramsActivationLog})});
      
      var dataUpdateActivation = {}

      var dataProductSerial = await DataServices.getList('request_activation_product_serial', {"variables": JSON.stringify({where_key: {
        request_activation_id: {'_eq': this.id },
        verify_status: {'_eq': 0},
        status: {'_eq': 1}
      }}), "fields": "id" });

      var listProductSerial = dataProductSerial[Object.keys(dataProductSerial)];
      if (listProductSerial == null || (listProductSerial != null && listProductSerial.length == 0)) {
        dataUpdateActivation = Object.assign(dataUpdateActivation, {process_status: 1, status: 1})
      }

      if (Array.isArray(this.acceptance_images)) {
        dataUpdateActivation  = Object.assign(dataUpdateActivation, {acceptance_images: JSON.stringify(this.acceptance_images)});
      }
      if (dataUpdateActivation && Object.keys(dataUpdateActivation).length) {
        await DataServices.updateData('request_activation', {"variables": JSON.stringify({data_update: dataUpdateActivation, where_key: {id: {'_eq': this.id}}})});
      }

      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
      this.showAcceptDialog = false;
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    closeAccept() {
      this.showAcceptDialog = false;
      this.submitCheck = false;
    },
    async acceptVerify() {
      this.submitCheck = true;
      var listPro = this.lstProducts.filter(a => a.verify_status == 0);
      if (this.lstProducts.length > 0 && listPro && Object.keys(listPro).length) {
        var lstSerialID = this.lstProducts.map(function(item) {return item.serial_number_id});
        var variablesSerial = {
          where_key: {
            serial_number_id : {'_in': lstSerialID },
            verify_status: {'_neq': 0},
            status: {'_eq': 1}
          }
        }
        var dataInfo = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id "});
        if (dataInfo != null &&  dataInfo[Object.keys(dataInfo)].length) {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Danh sách có sản phẩm không hợp lệ. Một số sản phẩm trong danh sách đã được nghiệm thu/kích hoạt bảo hành, vui lòng kiểm tra lại trước khi tiếp tục', life: 3000 });
        } else {
          this.showAcceptDialog = false;
          if (this.lstProducts.length > 0) {
            this.componentAcceptKey = Math.random()*2389;
            this.showAcceptDialog = true;
          }
        }
      }
    },
    async rejectVerify() {
      this.componentRejectKey = Math.random()*1209;
      this.reasonItem = {};
      this.changed_serial_number_id = '';
      this.reason_note = '';
      this.submitCheck = true;
      this.submitReject = false;
      var listPro = this.lstProducts.filter(a => a.verify_status == 0);
      if (this.lstProducts.length > 0 && listPro && Object.keys(listPro).length) {
        var lstSerialID = this.lstProducts.map(function(item) {return item.serial_number_id});
        var variablesSerial = {
          where_key: {
            serial_number_id : {'_in': lstSerialID },
            verify_status: {'_neq': 0},
            status: {'_eq': 1}
          }
        }
        var dataInfo = await DataServices.getList('product_serial_number_info', {"variables": JSON.stringify(variablesSerial), "fields": "serial_number_id "});
        if (dataInfo != null &&  dataInfo[Object.keys(dataInfo)].length) {
          this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Danh sách có sản phẩm không hợp lệ. Một số sản phẩm trong danh sách đã được nghiệm thu/kích hoạt bảo hành, vui lòng kiểm tra lại trước khi tiếp tục', life: 3000 });
        } else {
          this.showRejectDialog = true;
          this.reasonTypes = [];
          await this.settingReasonReject();
        }
      }
    },
    closeReject () {
      this.showRejectDialog = false;
      this.submitCheck = false;
    },
    openFile() {
      this.$refs.files.click();
    },
    chooseFile($event) {
      $event.preventDefault();
      $event.stopPropagation();
      var checkFile = false;
      var arrFiles = [];
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      for (let index = 0; index < fileSelects.length; index++) {
        const file = fileSelects[index];
        if (this.$myConstants.isImage(file.type)) {
          file.source = file;
          file.src = window.URL.createObjectURL(file);
          file.objectURL = window.URL.createObjectURL(file);
          arrFiles.push(file);
        } else {
          checkFile = true;
          break;
        }
      }
      if (checkFile) {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Sai định dạng file', life: 3000 })
      } else {
        this.files = this.files.concat.apply(this.files, arrFiles);
      }
    },
    removeImg(index) {
      this.files.splice(index, 1);
      if (this.files.length == 0) this.files = [];
    },
    onRowSelectedAll(data) {
      this.lstProducts = data;
    },
    onRowSelected(data) {
      this.lstProducts = data;
    },
    setIndex(index) {
      this.indexInvoice = index
    },
    setIndexUpload(index) {
      this.indexUpload = index
    }
  }
}
</script>
<style lang="scss">
.box-top-list{ margin-bottom: 0px;
  &.last-changed{margin-bottom: 15px;}
  span{font-size: 20; text-align: left; }
  .right-button{float: right;}
  .format-title{font-weight: bold; font-size: 25px;}
}
.box-info{ padding: 0 20px;
  &.list-product{margin-bottom: 30px;
    .custom-header{width: 60px !important;}
  }
  .box-info-title{ font-size: 16px; font-weight: 700; margin-bottom: 10px; margin-top: 20px;}
  .box-invoice-img{
    img{margin-right: 20px;
      &:last-child{margin: 0;}
    }
  }
  .form-info{
    .p-field{ padding: 10px;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
    }
  }
  &.log-changed{
    .p-datatable {
      .p-datatable-thead{
        tr {
          th {background: #169BD5;
            .p-column-title{color: #fff;}
          }
        }
      }
      .p-datatable-tbody{
        tr {
          td {
            &:last-child{text-align: left !important;}
          }
        }
      }
    }
  }
  .btn-function {margin-top: 15px;
    button{width: 170px; margin-right: 15px;}
  }
}
.dialog-reject{overflow: visible;
  .dialog-content{padding: 0 30px;
    p{font-size: 16px; margin: 0;}
  }
  .p-dialog-footer{text-align: center; border: 0 none; padding-bottom: 20px;
    button{width: 150px; margin-right: 15px; text-transform: uppercase;
      &:last-child{margin-right: 0;}
    }
  }
}
.custom-error{display: block; color: #f00; margin-top: 10px;}
.box-list-img{ margin: 0;
  .images-wrapper {
    .item-img {margin-bottom: 10px;
      .item{position: relative; text-align: center; width: 100%; margin: 0 auto;
        .remove-icon{cursor: pointer; position: absolute; right: -7px; top: -8px; color: #fff; background: #f00; width: 15px; height: 15px; overflow: hidden; border-radius: 50%;
          span{color: #fff; font-size: 8px; position: relative;top: -7.5px; left: 0px; font-weight: bold;}
        }
        .img {padding-top: 6px;
          img{max-width: 100%; height: auto;}
        }
      }
    }
  }
}
.images-wrapper { display: flex;
  .image {height: 150px; /*width: 100%;*/width: 150px; display: block; margin-right: 20px; cursor: pointer; background-size: cover;
    &:last-child{margin: 0;}
  }
}

</style>